export const LOCATIONS_REQUEST = 'locations/LOCATIONS_REQUEST';
export const LOCATIONS_SUCCESS = 'locations/LOCATIONS_SUCCESS';
export const LOCATIONS_ERROR = 'locations/LOCATIONS_ERROR';

export const GET_LOCATION_RESOURCES_REQUEST = 'locations/types.GET_LOCATION_RESOURCES_REQUEST';
export const GET_LOCATION_RESOURCES_SUCCESS = 'locations/types.GET_LOCATION_RESOURCES_SUCCESS';
export const GET_LOCATION_RESOURCES_FAILURE = 'locations/types.GET_LOCATION_RESOURCES_FAILURE';
